.twitter-embed {
  a {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  /* stylelint-disable-next-line selector-pseudo-class-no-unknown */
  &:has(:global(.twitter-tweet-rendered)) {
    a {
      display: none;
    }
  }
}

/* stylelint-disable-next-line selector-pseudo-class-no-unknown */
:global(.twitter-tweet) {
  margin: 0 auto;
  width: 100%;
}
